// Fair-demo data interface consumed by the mocks (mock-api.js, mock-realtime.js).
// All data is authored in dataset.js; this module only exposes accessors.

import * as data from './dataset'

export function getProperties () {
  return data.properties
}

export function getNuclei () {
  return data.nucleiFlat
}

export function getBarns () {
  return data.barnsFlat
}

export function getDevices () {
  return data.devicesFlat
}

// The realtime "enable" endpoint just needs to acknowledge; live values arrive
// via the mocked Realtime Database.
export function getDevicesRealtime () {
  return { enabled: true }
}

export function getBatchesByBarn (barnId) {
  return data.batchesByBarnId[barnId] || []
}

export function getWeightAnalysis (batchId) {
  return data.weightAnalysisByBatchId[batchId] || []
}

export function getProjection (batchId) {
  return data.projectionByBatchId[batchId] || { standard: [], genetics: [], usesCurve: false }
}

export function getMortalities (batchId) {
  return data.mortalitiesByBatchId[batchId] || []
}

export function getSilos (barnId) {
  return data.silosByBarnId[barnId] || []
}

export function getBreedCurves () {
  return data.breedCurves
}

export function getAlarmTranslators () {
  return data.alarmTranslators || []
}

export function getDeviceFeatures () {
  return data.deviceFeatures
}

// SMAAI 5 daily environment max/min (`statistics`).
export function getStatistics (mac) {
  return data.statisticsByMac[mac] || []
}

// InobramX daily environment max/min (`inobramx/maxmin`), internal or external.
export function getInobramxMaxMin (mac, external) {
  const source = external ? data.inobramxExternalMaxMinByMac : data.inobramxMaxMinByMac
  return source[mac] || []
}

// InobramX daily setpoints (`inobramx/setpoint`), temperature ('t') or humidity ('h').
export function getInobramxSetpoint (mac, metric) {
  const source = metric === 'h' ? data.inobramxHumSetpointsByMac : data.inobramxTempSetpointsByMac
  return source[mac] || []
}

// InobramX daily water consumption (`inobramx/performance`, metric 'h2o').
export function getInobramxWaterConsumption (mac) {
  return data.inobramxWaterByMac[mac] || []
}

// Alarm history (`alarms`), filtered by deviceIds (comma list) or barnId.
export function getAlarmHistory (query) {
  query = query || {}
  const records = data.alarmHistoryAll
  if (query.deviceIds) {
    const ids = String(query.deviceIds).split(',').filter(Boolean)
    return records.filter(function (r) { return ids.indexOf(r.deviceId) !== -1 })
  }
  if (query.barnId) {
    return records.filter(function (r) { return r.barnId === query.barnId })
  }
  return records
}

// Resolves the live status node for a device MAC, letting animated nodes vary
// their values over time via `tick`.
export function getLiveNode (mac, tick) {
  const node = data.liveNodesByMac[mac]
  if (typeof node === 'function') {
    return node(tick || 0)
  }
  return node || null
}



// WEBPACK FOOTER //
// ./src/demo/fixtures.js